import React, { Fragment } from 'react';
import { View, StyleSheet, FlatList, Image } from 'react-native';
import { Text } from 'exoflex';
import { checked, underDevelopment } from '../../assets';
import { POPOVER_COLOR } from '../constants/colors';

type Feature = {
  name: string;
  finished: boolean;
};
type Props = {
  pointerWidth: number;
  title: string;
  tintColor: string;
  details: string;
  data: Array<Feature>;
};

function Popover(props: Props) {
  let { pointerWidth, title, tintColor, details, data } = props;

  let renderItem = (item: Feature) => {
    return (
      <View style={styles.itemContainer}>
        <Text style={styles.flex}>{item.name}</Text>
        {item.finished && (
          <Image source={checked} style={styles.image} resizeMode="contain" />
        )}
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <View
        style={[
          styles.pointerContainer,
          { width: !data[0] ? 230 : pointerWidth },
        ]}
      >
        <View style={styles.outerTrianglePointer}>
          <View style={styles.innerTrianglePointer} />
        </View>
      </View>
      {!data[0] ? (
        <Fragment>
          <View style={styles.specialPopoverContent}>
            <Image source={underDevelopment} style={styles.logo} />
            <Text style={{ paddingTop: 16 }}>
              This feature is under development
            </Text>
          </View>
        </Fragment>
      ) : (
        <Fragment>
          <View style={styles.popoverContent}>
            <View style={styles.headerContainer}>
              <View
                style={[styles.tintColor, { backgroundColor: tintColor }]}
              />
              <Text weight="medium" style={styles.flex}>
                {title}
              </Text>
              <Text weight="normal" style={styles.details}>
                {details}
              </Text>
            </View>
            <View style={styles.divider} />
            <FlatList
              data={data}
              renderItem={({ item }) => renderItem(item)}
              keyExtractor={(_, index) => String(index)}
            />
          </View>
        </Fragment>
      )}
    </View>
  );
}
export default Popover;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  pointerContainer: {
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  outerTrianglePointer: {
    width: 0,
    height: 0,
    borderRightWidth: 10,
    borderBottomWidth: 10,
    borderLeftWidth: 10,
    borderTopColor: 'transparent',
    borderRightColor: 'transparent',
    borderLeftColor: 'transparent',
    borderBottomColor: POPOVER_COLOR.border,
    alignItems: 'center',
  },
  innerTrianglePointer: {
    width: 0,
    height: 0,
    borderRightWidth: 10,
    borderBottomWidth: 10,
    borderLeftWidth: 10,
    borderTopColor: 'transparent',
    borderRightColor: 'transparent',
    borderLeftColor: 'transparent',
    borderBottomColor: POPOVER_COLOR.background,
    bottom: -2,
  },
  popoverContent: {
    flex: 1,
    backgroundColor: POPOVER_COLOR.background,
    borderWidth: 1,
    borderColor: POPOVER_COLOR.border,
    borderRadius: 10,
    zIndex: -1,
    paddingVertical: 20,
    paddingHorizontal: 16,
  },
  specialPopoverContent: {
    flex: 1,
    backgroundColor: POPOVER_COLOR.background,
    borderWidth: 1,
    borderColor: POPOVER_COLOR.border,
    borderRadius: 10,
    zIndex: -1,
    paddingVertical: 20,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tintColor: {
    width: 8,
    height: 8,
    borderRadius: 8 / 2,
    marginRight: 16,
  },
  details: {
    color: POPOVER_COLOR.details,
  },
  divider: {
    height: 1,
    backgroundColor: POPOVER_COLOR.divider,
    marginTop: 13,
    marginBottom: 3,
  },
  flex: {
    flex: 1,
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
  },
  image: {
    width: 20,
    height: 20,
    paddingHorizontal: 10,
  },
  logo: {
    width: 96,
    height: 96,
    zIndex: 1,
  },
});
